import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '../selectors/auth'

interface GuestGuardProps {
	children?: React.ReactNode
}

const GuestGuard = ({ children }: GuestGuardProps) => {
	const user = useSelector(selectUser)

	if (user) {
		return <Navigate to="/dashboard" />
	}

	return <>{children}</>
}

export default GuestGuard
